import type React from 'react'
import { useEffect, useState } from 'react'
import styled from 'styled-components'

import Login from '@/components/Login'
import PageContainer from '@/components/PageContainer'
import Signup from '@/components/SignUp'
import ToggleSwitch from '@/components/ToggleSwitch'

export interface HandleLoginArgs {
  email?: string
  inviteCode?: string
  passReset?: string
}

interface Props {
  handleLogin: (state: HandleLoginArgs) => void
}

const Logo = styled.img`
  min-width: 130px;
  margin-right: 10px;
  width: 400px;
`

const OuterContainer = styled.div`
  display: grid;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const InnerContainer = styled.div`
  display: grid;
  grid-template-rows: min-content 300px;
  width: 600px;
`

const HeaderContainer = styled.div`
  text-align: center;
`

const ToggleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

const ToggleOption = styled.span`
  font-size: 1.3em;
`

const Auth: React.FC<Props> = ({ handleLogin }) => {
  const [isSignUp, setIsSignUp] = useState(false)

  const params = new URLSearchParams(window.location.search)
  const inviteId = params.get('inviteId')

  useEffect(() => {
    if (inviteId) {
      setIsSignUp(true)
    }
  }, [inviteId, setIsSignUp])

  function loginMiddleWare(state: any) {
    handleLogin(state)
  }

  return (
    <PageContainer>
      <OuterContainer>
        <InnerContainer>
          <HeaderContainer>
            <Logo src="/assets/goodlord-logo.png" />
            <h1>Referencing Dashboard</h1>
            <ToggleContainer>
              <ToggleOption>I have an account</ToggleOption>
              <ToggleSwitch toggle={() => setIsSignUp(!isSignUp)} value={isSignUp} />
              <ToggleOption>I'm new here</ToggleOption>
            </ToggleContainer>
          </HeaderContainer>
          <div>
            {isSignUp ? (
              <Signup
                onClickSignupManually={loginMiddleWare}
                onClickGmailSignup={loginMiddleWare}
              />
            ) : (
              <Login
                onClickForgotPassword={() => loginMiddleWare({ passReset: 'passReset' })}
                onClickLogin={() => loginMiddleWare(undefined)}
              />
            )}
          </div>
        </InnerContainer>
      </OuterContainer>
    </PageContainer>
  )
}

export default Auth
